import { array, object } from "superstruct";

import GiftRegistryTypeSchema from "./GiftRegistryTypeSchema";

const GiftRegistryTypesResponseSchema = object({
    giftRegistryTypes: array(GiftRegistryTypeSchema),
});

export default GiftRegistryTypesResponseSchema;
